import { render, staticRenderFns } from "./InfoManagePurchaser.vue?vue&type=template&id=280882ba&scoped=true"
import script from "./InfoManagePurchaser.vue?vue&type=script&lang=js"
export * from "./InfoManagePurchaser.vue?vue&type=script&lang=js"
import style0 from "./InfoManagePurchaser.vue?vue&type=style&index=0&id=280882ba&prod&lang=css"
import style1 from "./InfoManagePurchaser.vue?vue&type=style&index=1&id=280882ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280882ba",
  null
  
)

export default component.exports